import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import styled from 'styled-components';
import { Icon } from '@magalu/stereo-ui-icons';
import Button from '@magalu/stereo-ui/atoms/Button';
import Box from '@magalu/stereo-ui/atoms/Box';
import Flex from '@magalu/stereo-ui/atoms/Flex';
export var SharedActionsIcon = styled(Icon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: ", " !important;\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
export var SocialMediaButton = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 44px;\n  min-width: 0;\n  border-radius: 100%;\n  background-color: ", " !important;\n"])), function (_ref2) {
  var color = _ref2.color;
  return color;
});
export var SocialMediaContainerButtons = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 86px;\n"])));
export var SocialMediaContent = styled(Flex)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  align-items: center;\n  gap: 20px;\n  overflow-x: auto;\n"])));